import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { EmailAccountComponent } from './email-account/email-account.component';
import { CommonService } from '../../services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-email-set-up-summary',
  templateUrl: './email-set-up-summary.component.html',
  styleUrls: ['./email-set-up-summary.component.scss']
})
export class EmailSetUpSummaryComponent implements OnInit {
  columnDefs;
  operations;
  collapesedOrNot: boolean;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  tempoperations;
  isSettings:boolean=false;
  emailSetUpForm: UntypedFormGroup;
  constructor(
    //private router: Router,
    public route: ActivatedRoute,
   // private criteriaService: UmCriteriaService,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {
    this.collapesedOrNot = false;

    this.columnDefs = [
      {
        "field": "EmailID",
        "headerName": "Email ID"

      }
    ];

    this.advanceSearch = {
      "fields": [
        {
          "label": "Eamil ID",
          "field": "EmailID",
          "type": "text"
        }
      ]
    }
    this.emailSetUpForm = new UntypedFormGroup({
      EmailID: new UntypedFormControl("")
    });
    this.setOperations();
    this.setSummary();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {

  }



  onCallbackOperation(opr) {
    opr.callback();
  }


  edit() {
    let modalRef = this['self'].modalService.open(EmailAccountComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Edit',
      content:{OperationType:'Edit',ID: this['self'].selectedRow['EmailServerID'] }
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    });
  }

  view() {
    let modalRef = this['self'].modalService.open(EmailAccountComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-llg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'View',
      content:{OperationType:'View',ID: this['self'].selectedRow['EmailServerID'] }
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    });
  }


  map_privileges() {
  // const modalRef = this['self'].modalService.open(UmRoleMapPrivilegesViewModalComponent,
  //     {
  //       class: 'modal-vlg modal-full-height modal-right'
  //     });
  //     modalRef.componentInstance.Content={
  //       heading: 'Map Privileges',
  //       content: { id: this['self'].selectedRow['EmailServerID'] }
  //     }
  }

  map_users() {
    // const modalRef = this.modalService.open(UmRoleMapUsersViewModalComponent, {
    //   windowClass: 'modal-lg modal-full-height modal-right'
    // });
    // modalRef.componentInstance.Content={
    //   heading: 'Map Users',
    //   content: {
    //     heading: '', description: 'Work in Progress',
    //     id: this['self'].selectedRow['EmailServerID']
    //   }
    // }
  }

  setSummary() {
    this.SearchClear();
    //var formData = this.emailSetUpForm.value;
    this.summaryService.getEmailSetUpSummary(null).subscribe(summary => {
      this.rowData = summary;

    });
  }

   setDef(parmoperations:any): any {

    //this.tempoperations = parmoperations;
    this.operations = parmoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
     return this.operations;
  }

  setSearchSummary(formData) {

   let eID= this.emailSetUpForm.controls['EmailID'].value;
   if(eID == null || eID == "" || eID == undefined)
   {
      this.commonService.ValidationBanner("Please enter at least one criteria to perform search")
   }
    this.summaryService.getEmailSetUpSummary(eID).subscribe(summary => {
      this.rowData = summary;
    });
  }
  setOperations() {

    this.tempoperations = [ ];
    if(this.commonService.getScreenPermission("106","V")){
      this.isSettings=true;
      this.tempoperations.push({
        "name": "View",
          "id": "view"
      });
    }
    if(this.commonService.getScreenPermission("106","E")){
      this.isSettings=true;
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
    }
    if(this.commonService.getScreenPermission("106","N")){
      this.tempoperations.push({
        "name": "Add Email Account",
        "id": "add"
      });
    }

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  //// Advace search Functions
  SearchClear() {
    // this.emailSetUpForm = new UntypedFormGroup({
    //   EmailID: new UntypedFormControl("")
    // });
    this.emailSetUpForm.controls['EmailID'].setValue(null);


  //  this.setSummary();
  }

  AdvanceSearch() {
    var formData = this.emailSetUpForm.value;
    this.setSearchSummary(formData);
  }

  add(){
    //debugger;
    let modalRef = this['self'].modalService.open(EmailAccountComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content:{OperationType:'Add',ID: null }
    }
    modalRef.result.then(result => {
      this['self'].setSummary();
    });

  }

}
